import EdButton from "@/components/generic/edbutton/edButton";
import DeviceContext from "@/components/generic/customHooks/indentifyDevice";
import React from "react";

interface INcdIpoLoginForm {
  loginFunc: Function;
  guestApply: Function;
  name: string;
}
const NcdIpoLoginForm = (props: INcdIpoLoginForm) => {
  const device = DeviceContext();
  return (
    <div className="login-form-wrappar px-md-0 px-3 pt-3 pb-2">
      <div className="section-loginform-1">
        <div
          className={
            device && device.isDesktop
              ? "DMSan_22_500 txt_blackOne1"
              : "DMSans_16_500 txt_blackOne1"
          }
        >
          Do you have an account?
        </div>
        <div
          className={
            device && device.isDesktop
              ? "DMSanN_18_400 txt_primaryGrey account-login"
              : "DMSanN_14_400 txt_primaryGrey account-login"
          }
        >
          Your information will be prefilled and you can apply for your family
          and friends.
        </div>
      </div>
      <div className="login-button">
        <EdButton
          className={
            device && device.isDesktop
              ? "Login-blue-btn w-80"
              : "Login-blue-btn w-100"
          }
          value={" Login"}
          btnTyp="midnight-blue"
          slim
          onClick={() => {
            props?.loginFunc();
          }}
        />
      </div>
      <div>
        <div
          className={
            device && device.isDesktop
              ? "DMSan_22_500 txt_blackOne1  apply-for-ipo"
              : "DMSans_16_500 txt_blackOne1  apply-for-ipo"
          }
        >
          Apply for {props?.name} as a guest
        </div>
        <div className="Continue-without-btn">
          {" "}
          <EdButton
            className={
              device && device.isDesktop
                ? "Continue-without-noborder-btn w-80"
                : "Continue-without-noborder-btn small-edbutton w-100"
            }
            value={"Continue without Login"}
            btnTyp="midnight-blue-border"
            slim
            onClick={() => {
              props.guestApply();
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default NcdIpoLoginForm;
